import(/* webpackMode: "eager" */ "/home/jenkins/workspace/PwaSlotCash-test-pages/src/app/(pages)/rewards/page.tsx");
